/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'leftArrow': {
    width: 16,
    height: 16,
    viewBox: '0 0 10 18',
    data: '<g id="_x30_首页" transform="translate(-16 -84)"><path pid="0" id="Path-2" class="st0" d="M26 101.3l-.7.7-9.3-8.9 9.3-9.1.7.7-8.6 8.4z"/></g>'
  }
})



// WEBPACK FOOTER //
// ./src/views/icons/leftArrow.js